/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  ModalBody,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Text,
  Modal,
  VStack,
  Checkbox,
  HStack,
  ModalFooter,
  useToast,
} from '@chakra-ui/react';
import { useState } from 'react';
import Terms from './Terms';
import { Button } from '../../../components/atoms/Button';
import { useTheme } from '../../../contexts/ThemeProvider';
import { ICompanyForm, IDiscount, IStore } from '../FormPartner';

export function ApproveTermsModal({
  isOpen,
  onClose,
  onAccept,
  company,
  store,
  discount,
}: {
  isOpen: boolean;
  onClose: () => void;
  onAccept: () => void;
  company: ICompanyForm;
  store: IStore;
  discount: IDiscount;
}) {
  const [approved, setApproved] = useState(false);

  const toast = useToast();
  const { colors } = useTheme();

  const handleAssinar = () => {
    if(!approved){
      toast({
        title: 'Por favor, aceite os termos para continuar',
        status: 'error',
        duration: 3000,
      })

      return
    }
    onAccept();
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="xl">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Contrato Partiu - {company?.name}</ModalHeader>
        <ModalBody>
          <VStack height="50vh" overflow="scroll" width="100%" margin="auto">
            {typeof company !== 'undefined' && typeof discount !== 'undefined' && (
              <Terms company={company} store={store} discount={discount} />
            )}
          </VStack>
          <HStack onClick={() => setApproved(!approved)} cursor="pointer" marginTop="40px">
            <Checkbox isChecked={approved} onChange={(val: any) => setApproved(val)} />
            <Text>Estou de acordo com o contrato e desejo disponibilizar minha loja no Clube Partiu.</Text>
          </HStack>
        </ModalBody>
        <ModalFooter justifyContent="space-between">
          <Button
            borderColor={colors.primaryColor}
            color={colors.primaryColor}
            backgroundColor="transparent"
            width={'fit-content'}
            onClick={onClose}
            variant="outline"
          >
            Mudar Dados
          </Button>
          <Button width={'fit-content'} onClick={handleAssinar} disabled={!approved}>
            Assinar Digitalmente
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
